import React from 'react'
import { CustomField } from '@/components/Form/customFields/CustomField'
import CaluButton from '@/components/styledComponents/CaluButton'
import { Grid } from '@mui/material'

import s from '../styles.module.scss'

export const FormContent = ({ isLoading = false, formValues }) => {
  return (
    <>
      <Grid container spacing={2} className={s.containerForm}>
        <Grid item xs={12}>
          <p>
            <span>Servicio: </span>
            <span className={s.name}>{formValues?.service}</span>
          </p>
        </Grid>
        <Grid item xs={12}>
          <CustomField label="Precio" type="number" name="price" fullWidth />
        </Grid>

        <Grid item xs={12} className={s.contBtn}>
          <CaluButton color="primary" type="submit" size="medium" loading={isLoading}>
            Guardar
          </CaluButton>
        </Grid>
      </Grid>
    </>
  )
}
